module.exports = __webpack_public_path__ + "3d9b875a9b68996ef04aab4b72da6eee.fbx";